module.exports = __webpack_public_path__ + "static/img/COVER-12.064c4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER-12.png
// module id = CvY6
// module chunks = 31